export const picsData = [
  { className: 'footer-app-and', src: 'img/app-and.jpg', alt: 'Android' },
  { className: 'footer-app-ios', src: 'img/app-mob.jpg', alt: 'IOS' },
];
